import { render, staticRenderFns } from "./Customs.vue?vue&type=template&id=0fd6d38e"
import script from "./Customs.vue?vue&type=script&lang=js"
export * from "./Customs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports